import { z } from 'zod';
import { CommonFilter_Config_S, CommonFilter_RequestParams_S, CommonFilter_State_S } from './commonFilter.schema';
import { KeyWordFilterKey_S } from './keywordFilter.schema';

export const NumberFilterValue_S = z.object({
    value: z.number(),
    displayValue: z.number(),
});

export const NumberFilterValuesNumber_Config_S = z.object({
    from: z.number(), // min
    to: z.number(), // max
});

export const NumberFilterValues_Config_S = z.object({
    min: NumberFilterValue_S,
    max: NumberFilterValue_S,
    keywords: z.array(KeyWordFilterKey_S).optional(), // number filter could come with predefined keywords in configuration. If so, the number filter could act as a keyword filter
    histogram: z
        .array(z.object({ key: z.number(), min: z.number(), max: z.number(), doc_count: z.number() }))
        .optional(),
});

/**
 * NUMBER FILTER CONFIGURATION
 * */
export const NumberFilter_Config_S = CommonFilter_Config_S.extend({
    type: z.literal('integer').or(z.literal('float')),
    hasSearchInput: z.boolean().optional(),
    disabled: z.boolean(),
    values: NumberFilterValues_Config_S,
    preselected: NumberFilterValuesNumber_Config_S.or(z.array(z.string().or(z.number()))).optional(),
});

/**
 * NUMBER FILTER STATE
 * */
export const NumberFilter_State_S = NumberFilter_Config_S.merge(CommonFilter_State_S);

/**
 * NUMBER FILTER CONTROLS STATE
 */
export const NumberFilterValues_ControlsState_S = z.object({
    min: z.number(),
    max: z.number(),
    /* originalMin: z.number(),
    originalMax: z.number(), */
});

export const NumberFilter_ControlsState_S = NumberFilter_Config_S.pick({ identifier: true, type: true }).extend({
    applyFilter: z.boolean(),
    values: NumberFilterValues_ControlsState_S,
    isSystem: z.boolean(),
});

/**
 * NUMBER FILTER REQUEST PARAMS
 */
export const NumberFilter_RequestParams_S = CommonFilter_RequestParams_S.extend({
    from: z.number().int(),
    to: z.number().int(),
});

/**
 * NUMBER FILTER SNAPSHOT
 * */
export const NumberFilter_Snapshot_S = CommonFilter_Config_S.pick({ identifier: true }).extend({
    min: z.number(),
    max: z.number(),
});

/**
 * NUMBER FILTER STATE AGGREGATION RESPONSE
 * */
export const NumberFilterAggregation_S = z.object({
    min: z.number(),
    max: z.number(),
    histogram: z
        .array(z.object({ key: z.number(), min: z.number(), max: z.number(), doc_count: z.number() }))
        .optional(),
});
